<template>
    <div class="Evaluation_report_file">
      <transit :users="UserID"/>
      <div>
        <ul style="padding: 10px;padding-bottom: 30px;">
          <li>
            <span>姓名：</span>
            <span>{{ Data.RealName }}</span>
          </li>
          <li>
            <span>学生ID: </span>
            <span>{{ Data.UserID }}</span>
          </li>
          <li>
            <span>所属院系: </span>
            <span>{{ Data.DeptName }}</span>
          </li>
          <li>
            预警等级：
            <el-select size="medium" v-model="Type" placeholder="请选择上报类型" @change="type_switching()">
              <el-option label="全部" value=""></el-option>
              <el-option label="红色预警" value="红色预警"></el-option>
              <el-option label="橙色预警" value="橙色预警"></el-option>
              <el-option label="黄色预警" value="黄色预警"></el-option>
              <el-option label="蓝色预警" value="蓝色预警"></el-option>
              <el-option label="绿色预警" value="绿色预警"></el-option>
            </el-select>
          </li>
        </ul>

        <el-table :data="tableData" stripe style="width: 96%;margin-left: 2%;margin-top: 20px;">
          <el-table-column  prop="UserID" label="测评编号"></el-table-column>
          <el-table-column  prop="PublishSubject" label="发布主题"></el-table-column>
          <el-table-column  prop="StartTime" label="测试时间"></el-table-column>
          <el-table-column  prop="TestTime" label="测试用时"></el-table-column>
          <el-table-column  prop="Result" label="危机等级"></el-table-column>


          <el-table-column label="排查访谈" align="center">
            <template slot-scope="scope">
              <span @click="Crisis_Memcon_view(scope.row.TalkNo)"
                :style="scope.row.Percentage != 0 ? 'padding:20px; color: rgba(36, 153, 255, 1); cursor:pointer;' : 'padding:20px; color: rgba(166, 166, 166, 1); cursor:pointer;'">查看</span>
            </template>
          </el-table-column>


          <el-table-column  prop="address" label="测评报告">
            <template slot-scope="scope">
                <span @click="OpenCenterDialogVisible(scope.row)"
                  :style="scope.row.Percentage != 0 ? 'padding:20px; color: rgba(36, 153, 255, 1); cursor:pointer;' : 'padding:20px; color: rgba(166, 166, 166, 1); cursor:pointer;'">查看</span>
              </template>
          </el-table-column>

        </el-table>
      </div>

        <el-dialog title="测试报告" :visible.sync="centerDialogVisible" width="50%" center>
          <!-- <div style="background: rgba(225, 245, 233, 1);height: 40px;line-height: 40px;">
            <span style="margin-left: 20px; font-size: 14px; font-weight: 400;">{{ $t('original.name') }}：{{ Paperhead.Name
            }}</span>
            <span style="margin-left: 20px; font-size: 14px; font-weight: 400;"> {{ $t('original.gender') }}：{{ Paperhead.Sex
            }}</span>
            <span style="margin-left: 20px; font-size: 14px; font-weight: 400;"> {{ $t('original.Name_of_Company') }}：{{
              Paperhead.DeptName }}</span>
          </div> -->

          <table style="width: 100%;" class="Paperhead">
            <tr style="width: 100%;height: 40px;line-height: 40px;background: rgba(245, 247, 250, 1);">
              <th width="20%"> {{ $t('original.Test_scale') }}</th>
              <th width="20%"> {{ $t('original.languages106') }}</th>
              <th width="20%"> {{ $t('original.languages107') }}</th>
              <th width="20%">均分</th>
              <th width="20%"> {{ $t('original.languages73') }}</th>
            </tr>
            <tr v-for="item in PaperList" :key="item.index" style="height: 40px; line-height: 40px; text-align: center;">
              <td width="20%">{{ item.PaperName }}</td>
              <td width="20%">{{ item.PaperScoreR }}</td>
              <td width="20%">{{ item.PaperScoreS }}</td>
              <td width="20%">{{ item.PaperScoreA }}</td>
              <td width="20%"> <span style="color: rgba(0, 136, 255, 1);padding: 20px;cursor: pointer;"
                  @click="openReport(item.PaperResultID)"> {{ $t('original.languages174') }}</span>
               </td>
            </tr>
          </table>
        </el-dialog>
    </div>
</template>

<script>
import transit from './transit'
  export default {
    data(){
      return {
        PaperList: [],
        centerDialogVisible: false, //查看测评量表
        pageIndex: 1,
        UserID: '',
        Type: '',
        region:'',
        tableData: [],
        Data: [],
        Count: 0,
        Name: '',
        Sex: '',
        DeptName: '',

        
      }
    },
    components: {
      transit,
    },
  methods: {
    openReport(a) {
      let routeData = this.$router.resolve({
        path: '/visitors/ReportShow',
        query: { PaperResultID: a },
      });
      window.open(routeData.href, '_blank');
    },
    OpenCenterDialogVisible(row) {
        
        this.centerDialogVisible = true;
        // this.Paperhead.Name = row.RealName;
        // this.Paperhead.Sex = row.Sex;
        // this.Paperhead.DeptName = row.DeptName;
  
        this.$Http_Post('EmphasisClarification/GetPaperList', { UserID: row.UserID, PublishID: row.PublishID, }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.PaperList = res.Data;
          }
        });
    },
    Crisis_Memcon_view(TalkNo) {
      this.$router.push({
        path: '/Crisis/Crisis_Memcon_view',
        query: { TalkNo: TalkNo },
      });
    },
      type_switching() {//类型切换
        this.load();
      },
      load(form) {//列表
        this.$Http_Post('DistressPrediction/StuAssessmentReport', { PageIndex: this.pageIndex, PageSize: 10, UserID: this.UserID, Type: this.Type }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.tableData = res.Data;
            this.Count = Number(res.Counts);
          }
        })
      },
    },
    mounted(){
      this.UserID = [this.$route.query.UserID][0];
      this.$Http_Post('DistressPrediction/StuBasicFile', { UserID: this.UserID }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Data = res.Data;
        }
      });
      this.load();
    }
  }

</script>

<style>
.Evaluation_report_file{width: 100%;height: 100%;background-color: #fff;}
.Evaluation_report_file ul li{float: left;line-height: 40px;margin-left: 2%;}
</style>